<template>
<div class="page">
    <div class="address">
        <div class="item td-fsc">
            <div class="name">姓名</div>
            <input type="text" placeholder="请输入收货人姓名" v-model="form.name" required />
        </div>
        <div class="item td-fsc">
            <div class="name">联系电话</div>
            <input type="text" placeholder="请输入收货人手机号码" v-model="form.mobile" required />
        </div>
        <div class="item td-fsc">
            <div class="name">所在地区</div>
            <div class="picker" @click="selectArea">
                <span>{{ form.area || "请选择省市区" }}</span>
            </div>
        </div>
        <div class="item td-fbc">
            <div class="name">详细地址</div>
            <input type="text" placeholder="请输入详细地址" v-model="form.address" required />
        </div>
        <div class="item td-fbc">
            <div class="name">设为默认地址</div>
            <van-switch v-model="form.is_default" active-color="#586de0" inactive-color="#dcdee0" size="18px" />
        </div>
    </div>
    <div class="btn-box">
        <Btn class="save-btn td-w" loading @confirmEvent="submit">保存</Btn>
        <div class="save-btn td-fcc" @click="_importAddressFromWechat" v-if="isWeiXin">
            <span>导入微信地址</span>
        </div>
    </div>
    <!-- 地址选择 -->
    <PickerArea ref="PickerArea" :show="showArea" @confirm="areaConfirm" @cancel="areaCancel"></PickerArea>
</div>
</template>

<script>
import PickerArea from '@/components/PickerArea'
import {
    wxSetup,
    wxOpenAddress
} from '@/utils/wxShare'
export default {
    components: {
        PickerArea
    },
    data() {
        return {
            showArea: false, // 地区选择
            address_id: this.$route.query.id || "", // 地址ID
            form: {
                name: "",
                mobile: "",
                address: "",
                detail: "",
                is_default: false
            },
            area: [],
            isWeiXin: false,
        };
    },
    mounted() {
        this.isWeiXin = this.$isWeiXin();
        this._setupWechatConfig();
        this.getData();
    },
    methods: {

        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'addAddress',
                share_url: window.location.href.split('#')[0],
            };

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                wxSetup(result.data.share_config);
            }
        },

        // 提交表单
        async getData() {
            if (!this.address_id) return;
            let url = this.API.user_address_detail;
            let params = {
                id: this.address_id
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.form.name = result.data.name
                this.form.mobile = result.data.mobile
                this.form.area = result.data.area
                this.form.address = result.data.address
                this.form.is_default = result.data.is_default ? true : false
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 切换默认
        changeSwitch() {
            this.form.is_default = !this.form.is_default
        },
        /** 省市区选择 */
        // 打开地址选择
        selectArea() {
            this.showArea = true
        },

        _importAddressFromWechat() {
            wxOpenAddress((res) => {
                console.log('res---->', res);
                this.form.name = res.userName;
                this.form.mobile = res.telNumber;
                this.form.address = res.detailInfo;
                this.form.area = res.provinceName + res.cityName + res.countryName;
            });
        },

        // 地址选择确认
        areaConfirm(res) {
            this.showArea = false
            console.log('地址选择返回', res)
            let area = ""
            res.forEach(element => {
                area += element.name
            });
            this.area = res
            this.form.area = area
        },
        // 地址选择取消
        areaCancel() {
            this.showArea = false
        },
        // 提交表单
        async submit(done) {
            let {
                form
            } = this
            if (!form.name) {
                return this.Message({
                    title: "请输入收货人姓名",
                });
            }
            if (!form.mobile) {
                return this.Message({
                    title: "请输入收货人联系电话",
                });
            }
            if (!form.area) {
                return this.Message({
                    title: "请选择地区",
                });
            }
            if (!form.address) {
                return this.Message({
                    title: "请输入详细地址",
                });
            }

            let url = this.API.user_address_add;
            let params = {

                name: this.form.name,
                mobile: this.form.mobile,
                area: this.form.area,
                address: this.form.address,
                is_default: this.form.is_default ? 1 : 0,
            };
            // 编辑
            if (this.address_id) {
                params.id = this.address_id
            }
            let result = await this.$post(url, params);
            done && done()
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                    onClose: () => {
                        this.$router.go(-1)
                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.address {
    padding: 10px 15px;

    .item {
        padding: 10px;
        background-color: #fff;
        margin-bottom: 10px;
        border-radius: 6px;

        .name {
            font-size: 14px;
            color: #333;
            font-weight: 500;
        }

        input,
        .picker {
            flex: 1;
            font-size: 14px;
            line-height: 30px;
            height: 30px;
            text-align: right;
        }
    }
}

.btn-box {
    padding: 15px;
}

.save-btn {
    height: 35px;
    opacity: 1;
    background: linear-gradient(225deg, #9cb2f4, #6472e8);
    border-radius: 3px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 20px;
}
</style>
